module.exports = __webpack_public_path__ + "img/Portugal.d4af502b.png";